import { EntityId } from 'entities-next/common'

import { USER_MANAGER_DETAILS_PATH } from '../../UserManager.routes'

export const USER_MANAGER_DETAILS_FORM_DATA_PATH = `${USER_MANAGER_DETAILS_PATH}/details`
export function getUserDetailsFormDataPath(userId: EntityId) {
  return USER_MANAGER_DETAILS_FORM_DATA_PATH.replace(':userId', `${userId}`)
}

export const USER_MANAGER_CORPORATE_DETAILS_FORM_DATA_PATH = `${USER_MANAGER_DETAILS_PATH}/corporate`
export function getUserCorporateDetailsFormDataPath(userId: EntityId) {
  return USER_MANAGER_CORPORATE_DETAILS_FORM_DATA_PATH.replace(':userId', `${userId}`)
}

export const USER_MANAGER_DETAILS_CRITERIA_FORM_PATH = `${USER_MANAGER_DETAILS_PATH}/criteria`
export function getUserDetailsCriteriaFormPath(userId: EntityId) {
  return USER_MANAGER_DETAILS_CRITERIA_FORM_PATH.replace(':userId', `${userId}`)
}

export const USER_MANAGER_DETAILS_SEARCH_FUNCTIONS_FORM_PATH = `${USER_MANAGER_DETAILS_PATH}/search-functions`
export function getUserDetailsSearchFunctionsFormPath(userId: EntityId) {
  return USER_MANAGER_DETAILS_SEARCH_FUNCTIONS_FORM_PATH.replace(':userId', `${userId}`)
}

export const USER_MANAGER_DETAILS_SEARCH_CANDIDATES_VIEW_PATH = `${USER_MANAGER_DETAILS_SEARCH_FUNCTIONS_FORM_PATH}/:searchFunctionId/search-candidates`
export function getSearchCandidatesViewPath(userId: EntityId, searchFunctionId: EntityId) {
  return USER_MANAGER_DETAILS_SEARCH_CANDIDATES_VIEW_PATH.replace(':userId', `${userId}`).replace(
    ':searchFunctionId',
    `${searchFunctionId}`
  )
}

export const USER_MANAGER_DETAILS_SEARCH_CANDIDATE_RESULTS_PATH = `${USER_MANAGER_DETAILS_SEARCH_CANDIDATES_VIEW_PATH}/:searchCandidateId/results`
export function getSearchCandidateResultsPath(
  userId: EntityId,
  searchFunctionId: EntityId,
  searchCandidateId: EntityId
) {
  return USER_MANAGER_DETAILS_SEARCH_CANDIDATE_RESULTS_PATH.replace(':userId', `${userId}`)
    .replace(':searchFunctionId', `${searchFunctionId}`)
    .replace(':searchCandidateId', `${searchCandidateId}`)
}
